import {ultraSelect} from '../../html-components'

export default class View {
  
  constructor(controller) {
    this.controller = controller;
  }
  
  /**
   * Constructs nice none-SELECT-driven drop-down solution
   * @param {{
   *    buttonText: string,
   *    list: [{
   *      attributes: object,
   *      classes: string,
   *      content: string,
   *      events: [{
   *        name: string,
   *        callback: function}]
   *      }]
   *    }} options
   * @returns {Node}
   */
  ultraSelect(options) {
    return ultraSelect(options);
  }
}
